import Head from "next/head";

import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { authRefreshToken } from "../../utils/authGetRequest";
import { useCookies } from "react-cookie";
import * as Sentry from "@sentry/nextjs";
// import NotFoundSVG from "../../assets/images/404.svg";
const NotFoundSVG = (
  <svg width="460" height="368" viewBox="0 0 460 368" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2185_40403)">
      <path
        d="M290 247.936H204.153V249.976H187.211V219.445H172V322.555H187.211V255.779H204.153V258.245H210.325L216.321 287.394L216.253 287.491L216.353 287.551L221.967 315.347H224.665L222.633 305.292L224.878 303.899L234.793 310.022L230.861 312.962L230.914 315.552L237.122 311.452L245.149 315.845L245.567 313.669L239.439 310.014L247.35 305.091L256.244 310.131L252.237 312.625L251.711 315.765L258.698 311.528L264.232 315.207L264.252 312.416L261.14 310.099L269.954 304.931L272.034 306.155L270.235 314.974L272.986 314.909L283.864 258.241H290.004V247.936H290ZM229.713 258.249H238.588L244.037 261.513L234.584 267.115L224.677 261.232L229.713 258.249ZM222.284 259.803L219.666 258.249H224.922L222.284 259.803ZM248.823 261.525L254.369 258.249H262.163L267.637 261.537L258.24 267.171L248.823 261.525ZM255.859 268.597L246.51 274.199L236.981 268.533L246.434 262.939L255.859 268.597ZM246.442 260.096L243.346 258.249H249.566L246.442 260.096ZM244.129 275.62L234.628 281.319L224.971 275.632L234.584 269.946L244.129 275.62ZM234.644 284.162L243.571 289.414L234.52 295.036L225.256 289.788L234.644 284.162ZM237.025 282.728L246.514 277.042L255.184 282.19L245.9 287.956L237.025 282.728ZM257.562 283.603L267.665 289.603L258.449 295.329L248.297 289.362L257.562 283.603ZM257.529 280.74L248.912 275.62L258.244 270.022L266.669 275.07L257.529 280.74ZM260.617 268.597L270.026 262.963L278.234 267.878L268.994 273.612L260.617 268.597ZM266.918 258.249H273.13L270.034 260.108L266.918 258.249ZM212.96 258.249H214.879L219.887 261.228L214.257 264.557L212.96 258.249ZM214.779 267.083L222.28 262.646L232.187 268.529L222.561 274.219L215.381 269.99L214.779 267.083ZM216.04 273.219L220.156 275.644L216.927 277.552L216.04 273.219ZM217.345 279.564L217.63 279.981L222.565 277.062L232.235 282.756L222.798 288.402L218.686 286.069L217.345 279.564ZM219.337 289.245L220.397 289.844L219.565 290.346L219.337 289.245ZM222.111 302.738L221.983 302.116L222.553 302.465L222.111 302.738ZM224.878 301.019L221.304 298.815L220.083 292.876L222.846 291.225L232.155 296.498L224.878 301.019ZM237.122 308.581L227.203 302.461L234.588 297.875L244.924 303.73L237.122 308.581ZM247.281 302.264L236.945 296.409L245.948 290.816L256.092 296.779L247.281 302.264ZM258.678 308.713L249.719 303.629L258.489 298.188L267.548 303.521L258.678 308.713ZM272.52 303.613L272.367 303.525L272.556 303.413L272.52 303.613ZM273.15 300.317L273.102 300.252L269.95 302.104L260.822 296.731L270.03 291.004L274.435 293.622L273.15 300.317ZM274.929 291.077L272.371 289.555L275.608 287.547L274.929 291.077ZM276.234 284.278L269.998 288.153L259.903 282.154L269.022 276.484L276.821 281.166L276.234 284.278ZM277.327 278.596L271.371 275.022L278.917 270.336L277.327 278.596ZM279.752 265.935L272.411 261.533L277.897 258.245H281.23L279.752 265.935Z"
        fill="#9CA1AC"
      />
    </g>
    <path
      d="M230.764 202.416C221.07 196.764 214.246 189.407 210.293 180.345C206.34 171.283 205.344 160.84 207.305 149.014C209.266 137.189 214.201 124.429 222.108 110.733C229.991 97.0784 238.551 86.466 247.788 78.8958C257.066 71.3493 266.617 67.0224 276.441 65.9151C286.306 64.8314 296.057 67.0713 305.693 72.6347C315.33 78.1982 322.112 85.5313 326.042 94.6342C329.995 103.696 331.003 114.119 329.065 125.903C327.192 137.67 322.314 150.381 314.431 164.036C306.5 177.772 297.904 188.446 288.644 196.057C279.407 203.628 269.865 207.987 260.017 209.135C250.192 210.243 240.442 208.003 230.764 202.416ZM240.246 185.993C248.775 190.917 257.841 190.602 267.445 185.048C277.089 179.518 286.457 168.88 295.548 153.134C301.585 142.677 305.579 133.202 307.532 124.706C309.549 116.194 309.584 108.888 307.638 102.789C305.757 96.6728 302.007 91.9931 296.389 88.7497C287.901 83.8491 278.823 84.1846 269.155 89.756C259.487 95.3275 250.099 105.954 240.991 121.635C234.93 132.132 230.891 141.637 228.874 150.15C226.922 158.645 226.898 165.93 228.803 172.006C230.732 178.04 234.546 182.702 240.246 185.993Z"
      fill="#9CA1AC"
    />
    <path
      d="M10.9375 291.591V273.835L73.7926 174.545H87.7841V200.682H78.9062L33.9489 271.847V272.983H120.099V291.591H10.9375ZM79.9006 320V286.193L80.0426 278.097L80.0426 174.545H100.852L100.852 320H79.9006Z"
      fill="#9CA1AC"
    />
    <path
      d="M339.938 291.591V273.835L402.793 174.545H416.784V200.682H407.906L362.949 271.847V272.983H449.099V291.591H339.938ZM408.901 320V286.193L409.043 278.097V174.545H429.852V320H408.901Z"
      fill="#9CA1AC"
    />
    <defs>
      <clipPath id="clip0_2185_40403">
        <rect width="118" height="118" fill="white" transform="translate(172 212)" />
      </clipPath>
    </defs>
  </svg>
);

const NotFound = () => {
  const router = useRouter();
  const [cookies, setCookie] = useCookies(["token_access"]);
  const [show404, setShow404] = useState(false);

  useEffect(() => {
    authRefreshToken()
      .then((res) => {
        if (
          res.status_code !== 425 &&
          res.status_code !== 401 &&
          cookies.token_access !== "undefined" &&
          cookies.token_access !== undefined
        ) {
          setCookie("token_access", res.access_token);
          router.reload();
        } else {
          setShow404(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setShow404(true);
      });
  }, [cookies, setCookie]);

  useEffect(() => {
    Sentry.captureException("User redirected to 404 page", {
      extra: { referrer: router.asPath },
    });
  }, []);

  return (
    show404 && (
      <>
        <Head>
          <title>Bricked it! 404 | ShotQualityBets</title>
        </Head>
        <div className="notFoundContainer">
          {NotFoundSVG}
          <h4 className="notFoundHeader">Looks like that shot missed!</h4>
          <p className="notFoundParagraph">
            Whoops! It looks like the page you are looking for is stuck on the bench.{" "}
          </p>

          <button onClick={() => router.push("/")} className="orange-go-home-button">
            Take Me Back 🏀
          </button>
        </div>
      </>
    )
  );
};

export default NotFound;
